import { render, staticRenderFns } from "./tableRegistration.vue?vue&type=template&id=79096a33&"
import script from "./tableRegistration.js?vue&type=script&lang=js&"
export * from "./tableRegistration.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports